'use strict';

const createCookie = (name, value, expDays) => {
    let expires;
    if (expDays) {
        const date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

module.exports = createCookie;
